import React, { useEffect, useState } from 'react';

import { vwSet } from '../../utils/helpers';

import FilterBarMobile from './FilterBarMobile';
import FilterBarDesktop from './FilterBarDesktop';
import FilterBarFlint from './FilterBarFlint';

const AgendaFilters = ({
	activeSubSite,
	filteredCount,

	activeFilterDate,
	dateRange,
	setDateRange,
	activeTimestamp,
	activeCinema,
	activeTags,

	availableDates,
	availableDatesMonths,
	availableCinema,
	availableTags,

	filterDate,
	filterCinema,
	filterTags,
	resetFilters,

	currentConfig,
	rootElement,
}) => {

	const [showFilters, setShowFilters] = useState([]);

	const handleRange = (value, type) => {
		setDateRange(type);
		handleFilter('filterDate', value);
	}

	const handleFilter = (type, value, onlyActivate) => {
		if (type === 'filterDate') {
			filterDate(value);
			rootElement.querySelector(`.js_react_filter .js-date-button`).setAttribute('aria-expanded', 'false');
		}
		if (type === 'filterCinema') filterCinema(value);
		if (type === 'filterTags') filterTags(value, onlyActivate);
		if (type === 'resetFilters') resetFilters();
	};

	useEffect(() => {
    vwSet();
    window.addEventListener('resize', vwSet);
    return () => {
      window.removeEventListener('resize', vwSet);
    };
  }, [vwSet]);

	useEffect(() => {
		//check which types of filters we need for this tab/cinema
		const filterTypes = [];

		filterTypes.push('date');
		if (currentConfig.has_cinema_selector) {
			filterTypes.push('cinema');
		}
		availableTags.length >= 0 && filterTypes.push('tags');
		setShowFilters(filterTypes);
	}, []);

	if (showFilters.length <= 0) {
		return <></>;
	}

	if (currentConfig.theme === 'flint') {
		return (
			<>
				<FilterBarFlint
					activeFilterDate={activeFilterDate}
					activeTimestamp={activeTimestamp}
					activeCinema={activeCinema}
					activeTags={activeTags}
					availableDates={availableDates}
					availableDatesMonths={availableDatesMonths}
					availableCinema={availableCinema}
					availableTags={availableTags}
					currentConfig={currentConfig}
					showFilters={showFilters}
					handleFilter={handleFilter}
					handleRange={handleRange}
					dateRange={dateRange}
					rootElement={rootElement}
				/>
				<FilterBarMobile
					filteredCount={filteredCount}
					activeFilterDate={activeFilterDate}
					activeTimestamp={activeTimestamp}
					activeCinema={activeCinema}
					activeTags={activeTags}
					availableDates={availableDates}
					availableCinema={availableCinema}
					availableTags={availableTags}
					currentConfig={currentConfig}
					showFilters={showFilters}
					handleFilter={handleFilter}
				/>
			</>
		);
	}

	// idea
  	return (
    	<>
			{/* idea does not need a filterbar from mobile, handled in the styling */}
			{/* <FilterBarMobile
					filteredCount={filteredCount}
					activeFilterDate={activeFilterDate}
					activeTimestamp={activeTimestamp}
					activeCinema={activeCinema}
					activeTags={activeTags}
					availableDates={availableDates}
					availableCinema={availableCinema}
					availableTags={availableTags}
					currentConfig={currentConfig}
					showFilters={showFilters}
					handleFilter={handleFilter}
				/> */}

			<FilterBarDesktop
				activeFilterDate={activeFilterDate}
				activeTimestamp={activeTimestamp}
				activeCinema={activeCinema}
				activeTags={activeTags}
				availableDates={availableDates}
				availableDatesMonths={availableDatesMonths}
				availableCinema={availableCinema}
				availableTags={availableTags}
				currentConfig={currentConfig}
				showFilters={showFilters}
				handleFilter={handleFilter}
				handleRange={handleRange}
				dateRange={dateRange}
				rootElement={rootElement}
			/>
    	</>
  	);
};

export default AgendaFilters;
